const {
	generalSettings,
} = require("@parallelpublicworks/gatsby-clf/gatsby-options-index");
/**
 * pick relevant information from list entity
 */

module.exports = function transformListData(entities_list_entity) {
	// attributes that will be mapped to the list object
	const list_attributes = [
		"title",
		"field_entities_list_by_date",
		"field_entities_list_exclude_old",
		"field_view_unpublished",
		"field_columns",
		"field_entities_list_inc_promoted",
		"field_entities_list_limit",
		"field_entities_list_sort_by",
		"field_entities_list_sort_order",
		"field_entities_ulist_all",
		"field_entities_list_paging_mode",
		"field_is_private",
		"field_show_past_future_filter",
		"field_entities_list_show_filters",
		"field_entities_list_geo_field",
		"field_entities_list_hide_facets",
		"field_entities_list_summary_fld",
		"field_entities_list_use_elastic",
		"field_entities_list_mode",
		"field_promoted",
		"field_entities_list_flush",
		"field_entities_list_thumb_option",
		"field_entities_date_position",
		"field_entities_thumbnail_pos",
		"field_entities_thumbnail_size",
		"field_entities_thumbnail_align",
		"field_heading_type",
		"field_to",
		"field_entities_list_first_thumb",
		"field_table_columns",
		"field_has_date_range",
		"field_has_distance",
		"field_distances",
		"field_date_filter",
		"field_hide_links",
		"field_image_orientation",
		"field_sort_date_field_name",
		"field_entities_list_filter_prese",
		"field_show_filter_by_type",
		"field_entities_list_attr_facets",
		"field_entities_list_video_modal",
		"field_entities_list_hidden_info",
	];

	// define default values and short names for some list attributes
	const list_attributes_schema = {
		field_entities_list_show_filters: {
			type: "boolean",
			default: false,
			shortName: "showFilters",
		},
		field_entities_list_use_elastic: {
			type: "boolean",
			default: false,
			shortName: "useElastic",
		},
		field_entities_list_mode: {
			default: "grid",
			shortName: "mode",
		},
		field_entities_list_paging_mode: {
			default: null,
			shortName: "pagination",
		},
		field_columns: {
			default: 3,
			shortName: "cols",
		},
		field_entities_list_limit: {
			default: 0,
			shortName: "limit",
		},
		field_entities_list_flush: {
			type: "boolean",
			default: false,
			shortName: "flush",
		},
		field_entities_list_thumb_option: {
			shortName: "thumbOption",
		},
		field_entities_list_first_thumb: {
			type: "boolean",
			default: false,
			shortName: "firstThumbOnly",
		},
		field_heading_type: { default: "h3", shortName: "headingComponent" },
		field_entities_date_position: { default: "after", shortName: "datePosition" },
		field_entities_thumbnail_pos: {
			default: "before",
			shortName: "thumbnailPosition",
		},
		field_entities_thumbnail_size: { default: "full", shortName: "thumbnailSize" },
		field_entities_thumbnail_align: { default: "left", shortName: "thumbnailAlign" },
		field_to: { shortName: "moreLink" },
		field_has_date_range: {
			type: "boolean",
			default: false,
			shortName: "hasDateRange",
		},
		field_has_distance: {
			type: "boolean",
			default: false,
			shortName: "hasDistance",
		},
		field_show_filter_by_type: {
			type: "boolean",
			default: false,
			shortName: "showFilterByType",
		},
		field_date_filter: { shortName: "dateFilter" },
		field_image_orientation: {
			default: "landscape",
			shortName: "orientation",
			alternativeFieldName: "field_field_image_orientation",
		},
		field_entities_list_hidden_info: { shortName: "hiddenInfoPreset" },
	};

	const constants = {
		useElastic: generalSettings.data.siteMetaData.useElastic,
	};

	// relationships that will be mapped to the list object
	const list_relationships = [
		"field_content_type", // Relationships Display entities of type
		"field_entities_list_by_nodes", // By content relationship
		"field_entities_list_by_terms", // By term relationship
		"field_entities_list_by_content", // By content relationship
		"field_entities_list_by_specific", // List specific content
		"field_entities_list_by_types", // List all entities of type
		// "field_entities_list_by_mtypes", // List all media of type
		"field_entities_ulist_by_specific", // List specific users
		"field_entities_list_sort_options", // Sorting options from backend
		"field_entities_list_filter",
	];

	let list_data = {
		id: entities_list_entity.id,
		type: entities_list_entity.type,
		types: [],
	};
	for (const attr_name of list_attributes) {
		let sch = list_attributes_schema[attr_name];
		let attr = entities_list_entity.attributes[attr_name];
		if (!attr && sch && sch.alternativeFieldName) {
			attr = entities_list_entity.attributes[sch.alternativeFieldName];
		}
		if (attr_name === "field_entities_list_sort_by" && attr === "modified") {
			attr = "changed";
		}
		if (sch) {
			// if schema exists for this attribute, use it to transform the value
			let prop_name = sch.shortName || attr_name;
			let val;
			if (sch.type === "boolean") {
				val = attr === true;
			} else if (attr) {
				val = attr;
			} else if (sch.default) {
				val = sch.default;
			}
			list_data[prop_name] = val;
		} else {
			// otherwise, just use the attribute value
			list_data[attr_name] = attr ? attr : null;
		}
	}

	for (const rel_name of list_relationships) {
		if (entities_list_entity.relationships[rel_name]) {
			let rel_data = entities_list_entity.relationships[rel_name];
			if (
				(Array.isArray(rel_data.data) && rel_data.data.length > 0) ||
				(!Array.isArray(rel_data.data) && !!rel_data.data)
			) {
				list_data[rel_name] = Array.isArray(rel_data.data)
					? rel_data.data
					: [rel_data.data];

				/**
				 * collect predefined filters tu embed within elastic search queries
				 */

				// types: a list of entity types to filter requests search results
				if (
					rel_name === "field_entities_list_by_types"
					// || rel_name === "field_entities_list_by_mtypes"
				) {
					list_data.types = list_data.types.concat(list_data[rel_name]);
				}

				// types: a list of entity uuids to include only specific entities on elastic search requests
				if (rel_name === "field_entities_list_by_specific") {
					list_data.uuids = list_data[rel_name].map((m) => m.id);
				}
			}
		}
	}
	if (list_data.types && list_data.types.length > 0) {
		list_data.typeNames = list_data.types.map(
			(a_type) =>
				`${a_type.type.includes("media") ? "media" : "node"}--${
					a_type.meta.drupal_internal__target_id
				}`
		);
	} else {
		list_data.typeNames = [];
	}

	for (const [field_name, env_val] of Object.entries(constants)) {
		if (env_val) {
			list_data[field_name] = env_val;
		}
	}

	return list_data;
};
